import { render, staticRenderFns } from "./SettingsDisabledApps.vue?vue&type=template&id=4b0437c1&"
import script from "./SettingsDisabledApps.vue?vue&type=script&lang=ts&"
export * from "./SettingsDisabledApps.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports